import styled from 'styled-components';

import { Button } from 'components/Button';

const Container = styled.div`
  position: fixed;

  bottom: 3rem;
  right: 3rem;
`;

const Btn = styled(Button)`
  justify-content: center;
  align-items: center;

  width: 4rem;
  height: 4rem;
`;

export { Container, Btn };
